import { useRef, useState, useContext, useReducer, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";
import { useHistory } from "react-router-dom";
import { useFormContext } from "react-hook-form";
import { usePhoneValidation } from "../../../../Hooks/usePhoneValidation";
import { useSignature } from "../../../../Hooks/useSignature";
import VisitorParamsContext from "../../../../Contexts/VisitorParams";
import ErrorMessage from "./ErrorMessageSign";
import LOA from '../../../../assets/pdf/LOA_OD.pdf';
import TOB from '../../../../assets/pdf/Business_Terms_TMS.pdf';
import DECL from '../../../../assets/pdf/Overdraft_Declaration.pdf';
import VQ from '../../../../assets/pdf/Overdraft-Questionnaire.pdf';
import DSAR from '../../../../assets/pdf/DSAR_LOA_OVERDRAFT.pdf';
import GtmDataLayer from "../../../../Utility/GtmDataLayer";
import CheckBox2 from "./Checkbox2";
import UkCreditRating from "./UkCreditRating";

const Sign = ({
  basicDetailsValidation,
  openPrevPopup,
  setSignatureDataURL,
  setAgreement,
  onSignatureCompleted,
  formSubmit,
  signatureCompleted,
  setShowLoader
}) => {
  const initialState = {
    isAgreed: false,
    isCanvasEmpty: false,
    isValid: false,
    isChecked: false,
  };
  const signatureReducer = (state, action) => {
    switch (action.type) {
      case "signPadChange": {
        return {
          ...state,
          isCanvasEmpty: action.payload.value,
        };
      }
      case "validSignature": {
        return {
          ...state,
          isValid: action.payload.value,
        };
      }
      default:
        return state;
    }
  };
  const { phoneValidation } = usePhoneValidation();
  const { errors, register, setError, getValues } = useFormContext();
  const splitForm = useRef(null);
  const [state, dispatch] = useReducer(signatureReducer, initialState);
  const { saveSignature, isLoading } = useSignature();
  const history = useHistory();
  const { visitorParameters } = useContext(VisitorParamsContext);
  const signPadRef = useRef();
  const formParameters = JSON.parse(localStorage.getItem("formData"));
  const message_type = "signature_store";
  const [signatureWrapWidth, setSignatureWrapWidth] = useState(0);
  const [signatureWrapHeight, setSignatureWrapHeight] = useState(0);
  const [isDisable, setIsDisable] = useState(false)
  const [ukcActive, setUkcActive] = useState(false);
  const [basicDetailsValid, setBasicDetailsValid] = useState(false);
  const signatureWrapRef = useRef(null);
  const phoneNumber = getValues("txtPhone");
  const [isChecked, setIsChecked] = useState(true);
  const signDivRef = useRef(null);

  // Handle UKC iframe status change
  const handleUkcStatusChange = (status) => {
    console.log("UKC status received:", status);
    // Enable the button if active, already exists, or other terminal states
    if (["active", "account-exists", "manual", "broken_enroll"].includes(status)) {
      setUkcActive(true);
    }
  };

  // Check basic details validation and update UKC visibility
  const checkBasicDetailsAndShowUkC = async () => {
    // Reset UKC active state when re-validating
    setUkcActive(false);
    
    const validcheck = await basicDetailsValidation();
    setBasicDetailsValid(validcheck);
    
    return validcheck;
  };

  // Handle form data changes from UKC component
  const handleFormDataChange = async () => {
    console.log("Form data changed, re-validating and hiding UKC");
    await checkBasicDetailsAndShowUkC();
  };


  const validatePhoneNumber = async () => {
    console.log("phoneNumber", phoneNumber);
    const getPhoneValidation = await phoneValidation(phoneNumber);
    if (getPhoneValidation.data.status_code === 0) {
      setError("txtPhone", {
        type: "manual",
        message: "Please Enter Valid Working Phone Number",
      });
      document.getElementById("txtPhone").focus();
      return 0;
    } else if (getPhoneValidation.data.status_code === 2) {
      setError("txtPhone", {
        type: "manual",
        message: "Phone Number Already Exist",
      });
      document.getElementById("txtPhone").focus();

      return 0;
    } else if (getPhoneValidation.data.status_code === 3) {
      setError("txtPhone", {
        type: "manual",
        message: "Please Enter Valid Phone Number",
      });
      document.getElementById("txtPhone").focus();

      return 0;
    } else {
      return 1;
    }
  };
  const handleClick = async (e) => {
    // If UKC is already completed and active, show previous address popup
    if (ukcActive && signatureCompleted && basicDetailsValid) {
      if (openPrevPopup) {
        openPrevPopup();
      }
      return;
    }

    const validcheck = await checkBasicDetailsAndShowUkC();

    if (validcheck) {
      try {
        e.preventDefault();
        const signPad = signPadRef.current;
        if (signPad.isEmpty()) {
          return dispatch({ type: "signPadChange", payload: { value: true } });
        }

        const rpdata = signPad.toData();
        var signLength = 0;
        for (var i = 0; i < rpdata.length; i++) {
          signLength += Object.keys(rpdata[i]).length;
        }
        if (signLength > 13) {
          const validatePhone = await validatePhoneNumber();
          if (validatePhone) {
            const canvasDataURL = signPadRef.current
              .getCanvas()
              .toDataURL("image/png");
            setSignatureDataURL(canvasDataURL);
            GtmDataLayer({
              question: "signature",
            });
          }
        } else {
          console.log("Div",signDivRef.current);
          signDivRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
          return dispatch({ type: "validSignature", payload: { value: true } });
        }
      } catch (e) {
        console.warn(e);
      }
    }
  };

  useEffect(() => {
    if (!isChecked) {
      setAgreement(false);
    } else {
      setAgreement(true);
    }
  }, [isChecked]);

  // Auto-scroll to UkCreditRating when it becomes visible
  useEffect(() => {
    if (basicDetailsValid && signatureCompleted) {
      setTimeout(() => {
        const ukCreditSection = document.querySelector('.uk-credit-rating-section');
        if (ukCreditSection) {
          ukCreditSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 300);
    }
  }, [basicDetailsValid, signatureCompleted]);

  useEffect(() => {
    function handleResize() {
      setSignatureWrapWidth(signatureWrapRef.current.clientWidth);
      setSignatureWrapHeight(signatureWrapRef.current.clientHeight);
    }
    setSignatureWrapWidth(signatureWrapRef.current.clientWidth);
    setSignatureWrapHeight(signatureWrapRef.current.clientHeight);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const clearSign = () => {
    if (signPadRef.current) signPadRef.current.clear();
  };

  return (
    <>
      <div className="sign-sec" ref={signDivRef}>
        <h5 className=" mb-3 mt-4">
          PLEASE
          SIGN IN THE BOX BELOW TO START YOUR CLAIM
        </h5>
        <div className="signbox" ref={signatureWrapRef}>
          <SignatureCanvas
            canvasProps={{
              id: "myID",
              width: signatureWrapWidth,
              height: 200,
            }}
            ref={signPadRef}
            onEnd={() => {
              if (!signPadRef.current.isEmpty()) {
                dispatch({
                  type: "signPadChange",
                  payload: { value: false },
                });
                dispatch({
                  type: "validSignature",
                  payload: { value: false },
                });
                // Trigger callback when signature is drawn
                if (onSignatureCompleted) {
                  console.log("Signature drawn - calling onSignatureCompleted");
                  onSignatureCompleted();
                  
                  // Validate basic details and set basicDetailsValid
                  (async () => {
                    const validcheck = await basicDetailsValidation();
                    setBasicDetailsValid(validcheck);
                    
                    // Scroll to UKC after 500ms if basic details are completed and signature is valid
                    setTimeout(() => {
                      const ukCreditSection = document.querySelector('.uk-credit-rating-section');
                      if (ukCreditSection && validcheck) {
                        ukCreditSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
                      }
                    }, 500);
                  })();
                } else {
                  console.log("onSignatureCompleted callback not available");
                }
              }
            }}
          />
        </div>
        <div className="">
          {state?.isCanvasEmpty && (
            <ErrorMessage errMessage="Signature is required!" />
          )}
          {state?.isValid && <ErrorMessage errMessage="Draw valid signature!" />}
        </div>

      </div>
       <UkCreditRating
              show={basicDetailsValid && signatureCompleted}
              onStatusChange={handleUkcStatusChange}
              setShowLoader={setShowLoader}
              onFormDataChange={handleFormDataChange}
            />
      <div className="px-lg-0 px-md-0 px-sm-4 px-0 ">
        {/* <CheckBox2
          dataId="checkbox1"
          anchorText=""
          anchorStyle=""
          href=""
          onChange={() => {
            setIsChecked(!isChecked);
            dispatch({
              type: "privacyAgreed",
              payload: { value: isChecked },
            });
          }}
          className="checkinput me-2"
          value={isChecked}
          checked={isChecked}
          CheckBoxText={
            <>
              I agree to the processing of my personal data as outlined below.
              <br />
              I/We understand that The Money Solicitor will receive an Electronic Credit Report from CheckBoard and a soft footprint will be retained on my/our credit file.
            </>
          }
        /> */}
      </div>
      <div className="d-flex justify-content-between clearfixxx">
        <input
          type="button"
          id=""
          name=""
          className="clearbutton"
          value="Clear"
          onClick={clearSign}
        />

        <button
          className={`btn-comm2 w-50 mb-lg-0 mb-md-0 mb-sm-0 mb-3 z-0 ${ukcActive ? 'pulse2' : ''}`}
          id="formSubmitBtn"
          name="formSubmitBtn"
          type="button"
          onClick={handleClick}
          disabled={isDisable || (signatureCompleted && basicDetailsValid && !ukcActive)}
          style={{
            backgroundColor: (isDisable || (signatureCompleted && basicDetailsValid && !ukcActive)) ? '#b87979' : undefined,
            animation: (isDisable || (signatureCompleted && basicDetailsValid && !ukcActive)) ? 'none' : undefined,
            cursor: (isDisable || (signatureCompleted && basicDetailsValid && !ukcActive)) ? 'not-allowed' : 'pointer'
          }}
        >
          <span>Start</span>
        </button>
      </div>

      <div className="sign-blowtext mt-2 mt-lg-3">
        <div className="text-cp">
          <p className="fw-semibold ">
            We respect your privacy and give you control over your
            personal data. Please review the information below before
            giving your consent.
          </p>
          <p className="fw-semibold">
            {" "}
            By ticking the box, you agree to the following :{" "}
          </p>
        </div>

        <p className="sig-title mb-1">Consent for Data Processing</p>
        <p>
          You consent to TMS Legal using your data to represent you in any Responsible Lending and/or Mis-Sold Car Finance claims.
        </p>


        <p className="sig-title mb-1">Withdrawal of Consent</p>
        <p>
          You can withdraw consent at any time by contacting us.
          Withdrawal of consent will not affect the legality of any
          processing carried out before your request.
        </p>


        <p className="sig-title mb-1">Optional Consent</p>
        <p>
          Your consent is voluntary and not a condition for accessing
          our services.
        </p>
      </div>
    


    </>
  );
};

export default Sign;
